/**
 * 课程标准 api
 * 课程标准api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import IdNameVo from './IdNameVo';




  /**
   * The PaperSectionRuleVo model module.
   * @module course_standard/model/PaperSectionRuleVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>PaperSectionRuleVo</code>.
   * @alias module:course_standard/model/PaperSectionRuleVo
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>PaperSectionRuleVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:course_standard/model/PaperSectionRuleVo} obj Optional instance to populate.
   * @return {module:course_standard/model/PaperSectionRuleVo} The populated <code>PaperSectionRuleVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'paperSectionId')) {
        obj['paperSectionId'] = ApiClient.convertToType(data['paperSectionId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'knowledge')) {
        obj['knowledge'] = IdNameVo.constructFromObject(data['knowledge']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'quantity')) {
        obj['quantity'] = ApiClient.convertToType(data['quantity'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'drillCount')) {
        obj['drillCount'] = ApiClient.convertToType(data['drillCount'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * paper section id
   * @member {Integer} paperSectionId
   */
  exports.prototype['paperSectionId'] = undefined;
  /**
   * 知识点
   * @member {module:course_standard/model/IdNameVo} knowledge
   */
  exports.prototype['knowledge'] = undefined;
  /**
   * 抽题数
   * @member {Integer} quantity
   */
  exports.prototype['quantity'] = undefined;
  /**
   * 题库题数
   * @member {Integer} drillCount
   */
  exports.prototype['drillCount'] = undefined;



  export default exports;
;


